/* Play/pause for looping GIFs (WCAG 2.2.2).
   Page HTML uses a static placeholder — Shopify CDN does not freeze GIFs
   with format=jpg, so putting the file in src would autoplay flashing
   motion (WCAG 2.3.1 / 2.3.2). The first frame is captured for the poster. */
(function () {
  var PLACEHOLDER =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

  function decodeGifSrc(value) {
    if (!value) return '';
    if (value.indexOf('http') === 0 || value.indexOf('//') === 0 || value.indexOf('/') === 0) {
      return value;
    }
    try {
      return atob(value);
    } catch (err) {
      return value;
    }
  }

  function whenVisible(el, fn) {
    if (!('IntersectionObserver' in window)) {
      fn();
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          observer.disconnect();
          fn();
        }
      },
      { rootMargin: '200px' }
    );
    observer.observe(el);
  }

  function captureStill(gifSrc, callback) {
    var loader = new Image();
    /* CORS must be set before src. Shopify CDN GIFs are cross-origin;
       without this the canvas is tainted and toBlob fails. */
    loader.crossOrigin = 'anonymous';
    loader.onload = function () {
      try {
        var canvas = document.createElement('canvas');
        canvas.width = loader.naturalWidth || 1;
        canvas.height = loader.naturalHeight || 1;
        canvas.getContext('2d').drawImage(loader, 0, 0);
        canvas.toBlob(function (blob) {
          callback(blob ? URL.createObjectURL(blob) : '');
        }, 'image/jpeg', 0.85);
      } catch (err) {
        callback('');
      }
    };
    loader.onerror = function () {
      callback('');
    };
    loader.src = gifSrc;
  }

  function bind(root) {
    var button = root.querySelector('.gif-play__button');
    var image = root.querySelector('img');
    var gifSrc = decodeGifSrc(root.getAttribute('data-gif-src'));
    if (!button || !image || !gifSrc || button.dataset.bound === 'true') return;

    button.dataset.bound = 'true';
    if (image.id && !button.getAttribute('aria-controls')) {
      button.setAttribute('aria-controls', image.id);
    }

    var stillSrc = image.getAttribute('src') || PLACEHOLDER;
    var playLabel = root.getAttribute('data-play-label') || 'Play animation';
    var pauseLabel = root.getAttribute('data-pause-label') || 'Pause animation';

    function setPaused() {
      image.setAttribute('src', stillSrc);
      image.removeAttribute('srcset');
      button.setAttribute('data-state', 'paused');
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', playLabel);
    }

    function setPlaying() {
      image.removeAttribute('srcset');
      image.setAttribute('src', gifSrc);
      button.setAttribute('data-state', 'playing');
      button.setAttribute('aria-pressed', 'true');
      button.setAttribute('aria-label', pauseLabel);
    }

    whenVisible(root, function () {
      captureStill(gifSrc, function (url) {
        if (url) stillSrc = url;
        image.dataset.stillSrc = stillSrc;
        if (button.getAttribute('data-state') !== 'playing') {
          setPaused();
        }
      });
    });

    button.addEventListener('click', function () {
      if (button.getAttribute('data-state') === 'playing') {
        setPaused();
      } else {
        setPlaying();
      }
    });
  }

  function init() {
    document.querySelectorAll('.gif-play[data-gif-src]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
